<template>
  <div v-if="images" class="box alt">
    <div v-if="!isSmallTouchDevice() && cover" class="image main"><img alt="Projekt Cover" :src="cover" /></div>
    <VueGallery :id="id" :images="modifiedImages" :index="galleryIndex" @close="galleryIndex = null"></VueGallery>

    <div v-if="thumbs && thumbs.length>0" class="row gtr-50 gtr-uniform" :class="{'project-gallery':!isSmallTouchDevice()}">
      <div v-for="(img,index) in thumbs" :key="index" class="col-4 col-12-small"><span class="image fit"><a href="" @click.prevent="openFullscreen(img,index)"> <img alt="Projektbild" class="projectImg" :src="img"></a></span></div>
    </div>

    <!-- Modals -->
    <!--
		<RTmodal ref="galleryFullscreenModal">
        <img class="fullscreenImg" :src="this.selectedImg" alt="">
    </RTmodal>
    -->
  </div>
</template>

<script>
import {helper} from '@/mixins/helper.js'
import VueGallery from 'vue-gallery';
//import RTmodal from '@/components/RTmodal.vue'
export default {
  name: 'RTProjectGallery',
  mixins:[helper],
  components:{
    VueGallery
    //RTmodal
  },
  props:{
    id:{
      type:String
    },
    images:{
      type:Array
    },
    cover:{
      type:String
    },
    preview:{
      type:Boolean,
      default:false,
    }
  },
  watch:{
  },
  data: function() {
    return {
      galleryIndex:null,
      selectedImg:null
    };
  },
  computed:{
    thumbs(){
      return this._.map(this.modifiedImages,(src)=>{
        if(src && !src.startsWith('https')){
          let ar= src.split('/');
          let a =ar.pop();
          ar.push('thumbs');
          ar.push(a);
          return ar.join('/');
        }
        return src;
      });
    },
    modifiedImages(){
      let counter=0;
      let maxCount=(this.preview)?3:9;
      let mobileDev=this.isSmallTouchDevice();

      let imgs=this._.clone(this.images);
      if(mobileDev && this.cover && this.cover.trim!=""){
        imgs.unshift(this.cover)
      }

      return this._.filter(imgs,()=>{
          counter++;
					return (counter<=maxCount)
      });
    }
  },
  methods:{
    showFullscreenModal() {
      if(this.$refs.galleryFullscreenModal){
        this.$refs.galleryFullscreenModal.show();
      }
		},
    openFullscreen(img,index){
      this.galleryIndex=index;
      if(img){
        this.selectedImg=img;
        this.showFullscreenModal();
      }
    }
  },

  mounted(){

  },
};
</script>

<style type='text/css'>
.fullscreenImg{
  width:100%;
  height:auto;
  padding:1rem;
}
.blueimp-gallery{

}
.blueimp-gallery .close{
  left:0!important;
  margin-left:0.2rem;
}
.projectImg{

}
.project-gallery{
    max-height: 150px;
    overflow: hidden;
}
</style>